import { buildAuthorizationHeader } from 'owa-tokenprovider-utils';
import { ErrorCodes } from '../utils/errorCodes';
import { trace } from 'owa-trace';
import { getAccessTokenforResource } from 'owa-tokenprovider';
import { isIOSBackgroundCall } from 'mini-common-utils/lib/utils/isIOSBackgroundCall';
import { isNullOrUndefined } from 'mini-common-utils/lib/utils/isNullOrUndefined';

/**
 * This method is responsible for adding the required headers and the correct token to make the SDS network call.
 */

/* eslint-disable-next-line @typescript-eslint/no-explicit-any --
 * See aka.ms/mini-lint-errors
 *	> Unexpected any. Specify a different type. */
export async function makeSDSNetworkCall(url: string, method?: string, body?: any) {
    let response = null;
    const isBodyPresent: boolean = !isNullOrUndefined(body);
    try {
        const substrateToken = await getAccessTokenforResource(window.location.origin);
        if (!substrateToken) {
            trace.warn('[makeSDSNetworkCall]: SDS API failure. Token unavailable.');
            return response;
        }
        const substrateHeaders = new Headers();
        substrateHeaders.append('Accept', 'application/json');
        substrateHeaders.append('Authorization', buildAuthorizationHeader(substrateToken));
        substrateHeaders.append('Prefer', 'exchange.behavior="applicationdata"');
        substrateHeaders.append('Content-type', 'application/json');
        const serviceData = await fetch(url, {
            headers: substrateHeaders,
            method: method ? method : 'GET',
            body: JSON.stringify(body),
        });
        response = await serviceData.json();
        const shouldSuppressErrorLogs: boolean =
            response?.error?.code === ErrorCodes.CollectionIdNotFound && method === 'GET';
        if (response?.error && !shouldSuppressErrorLogs) {
            const { code = '', message = '' } = response.error;
            trace.warn(
                'SDS api error, Method - ' +
                    method +
                    ', code - ' +
                    code +
                    ', message - ' +
                    message +
                    ', body present - ' +
                    isBodyPresent +
                    ' request-id - ' +
                    serviceData.headers?.get('Request-Id') +
                    ' url - ' +
                    url
            );
        } else if (response == null || response === undefined) {
            trace.warn('SDS api response is null or undefined');
        }
    } catch (e) {
        response = null;
        if (isIOSBackgroundCall()) {
            trace.warn(
                '[warning] SDS api failure in iOS, Method - ' +
                    method +
                    ', body present - ' +
                    isBodyPresent +
                    ', url - ' +
                    url +
                    ', error message - ' +
                    e.message +
                    ', error stack - ' +
                    e.stack
            );
        } else {
            trace.warn(
                'SDS api failure, Method - ' +
                    method +
                    ', body present - ' +
                    isBodyPresent +
                    ', url - ' +
                    url +
                    ', error message - ' +
                    e.message +
                    ', error stack - ' +
                    e.stack
            );
        }
    }
    return response;
}
